import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { store } from "./store/Store.js";
import "./registerServiceWorker";
import { APIEndpoint, APIServices, auth } from "./constants/config";
import http from "./services/http";
import vSelect from "vue-select";
import Toast, { useToast } from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createNotify } from "./utils/notify";

// Tailwind first, then app SCSS. Typography that must beat Preflight also
// lives after `@tailwind base` inside tailwind.css (CSS extract order can
// place this file after style.scss in production builds).
import "./tailwind.css";
import "@/assets/scss/style.scss";
// Toast overrides last so they beat vue-toastification defaults
import "@/assets/scss/components/_Toasts.scss";

import "vue-select/dist/vue-select.css";

// Configuración de font awesome
import { library } from "@fortawesome/fontawesome-svg-core"; //Librería general de fontawesome
import AOS from "aos";
import "aos/dist/aos.css";

/*  Icons   */
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faFontAwesome,
  faFacebookF,
  faTwitter,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import {
  faPaperPlane,
  faKey,
  faCommentDots,
  faUser,
  faUserEdit,
  faUserSecret,
  faArrowLeft,
  faArrowRight,
  faTimes,
  faPlusCircle,
  faShoppingCart,
  faFileInvoice,
  faCheckCircle,
  faExclamationTriangle,
  faLightbulb,
} from "@fortawesome/free-solid-svg-icons";
import TopBar from "@/components/TopBar/TopBar.vue";
library.add(
  faFileInvoice,
  faPaperPlane,
  faKey,
  faCommentDots,
  faUser,
  faUserEdit,
  faUserSecret,
  faFacebookF,
  faTwitter,
  faInstagram,
  faFontAwesome,
  faArrowLeft,
  faArrowRight,
  faTimes,
  faPlusCircle,
  faShoppingCart,
  faCheckCircle,
  faExclamationTriangle,
  faLightbulb
);

import Loader from "./components/Loader.vue";
import TLabel from "./components/TailwindComponents/TLabel.vue";
import AppModal from "./components/ui/AppModal.vue";
import AppDatePicker from "./components/ui/AppDatePicker.vue";

const app = createApp(App);
app.use(Toast, {
  position: "top-right",
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  maxToasts: 4,
  newestOnTop: true,
  transition: "Vue-Toastification__slideBlurred",
});
const toast = useToast();
const notify = createNotify(toast);
app.config.globalProperties.$toast = toast;
app.config.globalProperties.$notify = notify;
// SweetAlert removed — use this.$notify.success|warning|info|danger
app.use(router);
app.use(store);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component("appTopbarNav", TopBar);
app.component("v-select", vSelect);
app.component("t-label", TLabel);
app.component("t-loader", Loader);
app.component("t-modal", AppModal);
app.component("t-datepicker", AppDatePicker);

app.config.globalProperties.$http = http;
app.config.globalProperties.$auth = auth;
app.config.globalProperties.$APIEndpoint = APIEndpoint;
app.config.globalProperties.$APIServices = APIServices;

AOS.init();
const userString = localStorage.getItem("user");
if (userString) {
  store.commit("SET_USER", JSON.parse(userString));
}

app.mount("#app");
